import RestService from "./rest.service";

class Calibration {
  getListCalibrationTemplate(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/template?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getDropdownCalibrationTemplate(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/dropdown/evaluate-journey?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  getCalibrationTemplate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/template/${id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }
  createCalibrationTemplate(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/template/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }
  launchCalibrationSession(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/session/launch`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }
  reStartCalibrationSession(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/session/restart`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }
  editCalibrationTemplate(data, id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.puts(`app/admin/kpi/calibration/template/${id}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }
  deleteCalibrationTemplate(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/calibration/template/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }

  getListCalibrationSession(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      if (cycle_id !== undefined && cycle_id !== null && cycle_id !== "") {
        RestService.gets(`app/admin/kpi/calibration/session?cycle_id=${cycle_id}`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      } else {
        RestService.gets(`app/admin/kpi/calibration/session`).then(
          (response) => {
            fnResolve(response);
          },
          (response) => {
            fnReject(response);
          }
        );
      }
    })
  }

  listDropdown() {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/session/add`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listFormCalibrationTemplete(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/dropdown/calibration-template?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  listDropdownManager(cycle_id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/dropdown/manager?cycle_id=${cycle_id}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  validate(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/session/validate`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }

  createCalibrationSession(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/session/add`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }

  detailCalibrationSession(serial) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/session/${serial}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  editCalibrationSession(data, id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.put(`app/admin/kpi/calibration/session/${id}/edit`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }
  deleteCalibrationSession(id) {
    return new Promise((fnResolve, fnReject) => {
      RestService.delete(`app/admin/kpi/calibration/session/${id}/delete`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    })
  }

  listSubCriteria(criteria, cycleID) {
    return new Promise((fnResolve, fnReject) => {
      RestService.gets(`app/admin/kpi/calibration/session/criteria/${criteria}?cycle_id=${cycleID}`).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  getMinMax(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/admin/kpi/calibration/template/scale/minmax`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

  uploadFiles(data) {
    return new Promise((fnResolve, fnReject) => {
      RestService.posts(`app/kpi/calibration/import`, data).then(
        (response) => {
          fnResolve(response);
        },
        (response) => {
          fnReject(response);
        }
      );
    });
  }

}

export default new Calibration();
